import React from "react"
import PropTypes from "prop-types"
import { useInView } from "react-cool-inview"

const Waypoint = ({ onEnter, onLeave, threshold, children, ...rest }) => {
  const { observe } = useInView({
    threshold: threshold || 0.8,
    onEnter: () => {
      onEnter()
    },
    onLeave: onLeave
      ? () => {
          onLeave()
        }
      : undefined,
  })

  return (
    <div ref={observe} {...rest}>
      {children}
    </div>
  )
}

Waypoint.propTypes = {
  onEnter: PropTypes.func.isRequired,
  onLeave: PropTypes.func,
  threshold: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default Waypoint
